(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[398],{

/***/ 84009:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-account",
      function () {
        return __webpack_require__(18572);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57908:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/rx-number.1a91677e.png","height":250,"width":327,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAIAAABxZ0isAAAAmklEQVR42g3LMQuCQBiA4e/HBS4FCo6BP+9ECCTIsRQx77PBU7E7uwoHZw80nMTrnuldXgjP8Sm81lXN66opSylfv3le1xWEEJco+nZdkyQfxoZheBtSAufc98mjKCgipbRAfLatEBz6vk/TdFkWNY5KqWma9LZprYEQEgRBydg9zxHRfFmW3eIYjKPnHRxnZ1l723Zc1zQA/AEhXWiiAvrdawAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 18572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var D_a_1_s_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35666);
/* harmony import */ var D_a_1_s_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(D_a_1_s_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97375);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(79762);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4612);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(15193);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(27311);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(87536);
/* harmony import */ var components_CMS__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60100);
/* harmony import */ var components_common_ProxiedImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96042);
/* harmony import */ var _public_assets_rx_number_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57908);
/* harmony import */ var components_stores__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49647);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2196);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48847);
/* harmony import */ var components_forms_inputs_MaskedDateInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2443);
/* harmony import */ var components_common_LDLink__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67691);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59830);
/* harmony import */ var components_GlobalErrors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53384);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11163);
/* harmony import */ var api_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40778);

















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CreateAccount = function() {
    var ref10;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(undefined), pharmacySelected = ref1[0], setPharmacySelected = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), pharmacyLocation = ref2[0], setPharmacyLocation = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), currentStep = ref4[0], setCurrentStep = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(undefined), apiError = ref5[0], setApiError = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), patientId = ref6[0], setPatientId = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), userPhone = ref7[0], setUserPhone = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), userAccount = ref8[0], setUserAccount = ref8[1];
    // const [redirectInterval, setRedirectInterval] = useState(0)
    var step1Form = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_15__/* .useForm */ .cI)();
    var step2Form = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_15__/* .useForm */ .cI)();
    var pharmacyModalControls = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__/* .useDisclosure */ .qY)();
    var rxImageModalControls = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_16__/* .useDisclosure */ .qY)();
    var ref9 = (0,store__WEBPACK_IMPORTED_MODULE_7__/* .useStore */ .oR)(), locationStore = ref9.locationStore, patientStore = ref9.patientStore;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_13__.useRouter)().query;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (typeof (query === null || query === void 0 ? void 0 : query.step) === 'string' && parseInt(query.step) === 3) {
            setCurrentStep(3);
        }
        if (typeof (query === null || query === void 0 ? void 0 : query.userPhone) === 'string') {
            setUserPhone(query.userPhone);
        }
    }, [
        query
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (pharmacySelected) {
            var ref;
            var locationData = (ref = locationStore.locations) === null || ref === void 0 ? void 0 : ref.get(pharmacySelected);
            if (locationData) setPharmacyLocation(locationData);
        }
    }, [
        locationStore.locations,
        pharmacySelected
    ]);
    var onSubmitStep1 = _asyncToGenerator(D_a_1_s_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        var ref, ref11, params, res, ref12, ref13, ref14, ref15, rows, match, ref16;
        return D_a_1_s_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    setIsLoading(true);
                    setApiError(undefined);
                    params = _objectSpread({
                    }, values, {
                        phone: (ref = values.phone) === null || ref === void 0 ? void 0 : ref.replace(/\D/g, '').replace(/^1/, ''),
                        storetelephone: (ref11 = (pharmacyLocation === null || pharmacyLocation === void 0 ? void 0 : pharmacyLocation.pharmacyPhone) || (pharmacyLocation === null || pharmacyLocation === void 0 ? void 0 : pharmacyLocation.phone)) === null || ref11 === void 0 ? void 0 : ref11.replace(/\D/g, '')
                    });
                    _ctx.next = 6;
                    return patientStore.verifyRxAndPhone(params);
                case 6:
                    res = _ctx.sent;
                    setIsLoading(false);
                    if (res === null || res === void 0 ? void 0 : res.hasError) {
                        ;
                        if ((res === null || res === void 0 ? void 0 : (ref12 = res.error) === null || ref12 === void 0 ? void 0 : ref12.toLowerCase()) == "no pickup group") {
                            setApiError(utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .PHONE_NUMBER_NOT_REGISTERED_PROMPT */ .RO);
                        } else if ((ref14 = res === null || res === void 0 ? void 0 : (ref13 = res.error) === null || ref13 === void 0 ? void 0 : ref13.toLowerCase()) === null || ref14 === void 0 ? void 0 : ref14.includes("Windows socket error".toLowerCase())) {
                            setApiError(api_constants__WEBPACK_IMPORTED_MODULE_14__/* .TECHNICAL_DIFFICULTIES_ERROR */ .Pl);
                        } else {
                            setApiError(res.error);
                        }
                    } else {
                        ;
                        rows = res === null || res === void 0 ? void 0 : (ref15 = res.Verifyrxt) === null || ref15 === void 0 ? void 0 : ref15.row;
                        match = rows === null || rows === void 0 ? void 0 : rows.find(function(param) {
                            var Rxnumber = param.Rxnumber;
                            return Rxnumber === values.rxnumber;
                        });
                        if (match) {
                            ;
                            setPatientId(match === null || match === void 0 ? void 0 : match.patid);
                            setUserPhone((ref16 = values.phone) === null || ref16 === void 0 ? void 0 : ref16.replace(/\D/g, ''));
                        }
                        setCurrentStep(2);
                    }
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    var onSubmitStep2 = _asyncToGenerator(D_a_1_s_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        var ref, ref17, ref18, ref19, params, res, ref20, ref21, ref22, params1, res1, ref23, ref24, _error, ref25, ref26, ref27;
        return D_a_1_s_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    setIsLoading(true);
                    params = _objectSpread({
                    }, values, {
                        patid: patientId,
                        storetelephone: (ref = (pharmacyLocation === null || pharmacyLocation === void 0 ? void 0 : pharmacyLocation.pharmacyPhone) || (pharmacyLocation === null || pharmacyLocation === void 0 ? void 0 : pharmacyLocation.phone)) === null || ref === void 0 ? void 0 : ref.replace(/\D/g, '')
                    });
                    _ctx.next = 5;
                    return patientStore.verifyDobAndPhn(params);
                case 5:
                    res = _ctx.sent;
                    setIsLoading(false);
                    if (!(res === null || res === void 0 ? void 0 : res.hasError)) {
                        _ctx.next = 11;
                        break;
                    }
                    {
                        ;
                        if ((ref21 = res === null || res === void 0 ? void 0 : (ref20 = res.error) === null || ref20 === void 0 ? void 0 : ref20.toLowerCase()) === null || ref21 === void 0 ? void 0 : ref21.includes("Windows socket error".toLowerCase())) {
                            setApiError(api_constants__WEBPACK_IMPORTED_MODULE_14__/* .TECHNICAL_DIFFICULTIES_ERROR */ .Pl);
                        } else {
                            setApiError(res.error);
                        }
                    }
                    _ctx.next = 21;
                    break;
                case 11:
                    if (!((res === null || res === void 0 ? void 0 : (ref17 = res.Verifybphn) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.row) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.Matched) === 'N')) {
                        _ctx.next = 15;
                        break;
                    }
                    {
                        setApiError('Date of birth or Personal Health Number does not match our records. Please try again or contact your pharmacy.');
                    }
                    _ctx.next = 21;
                    break;
                case 15:
                    ;
                    params1 = {
                        patid: patientId,
                        storetelephone: (ref22 = (pharmacyLocation === null || pharmacyLocation === void 0 ? void 0 : pharmacyLocation.pharmacyPhone) || (pharmacyLocation === null || pharmacyLocation === void 0 ? void 0 : pharmacyLocation.phone)) === null || ref22 === void 0 ? void 0 : ref22.replace(/\D/g, '')
                    };
                    _ctx.next = 19;
                    return patientStore.addNewCard(params1);
                case 19:
                    res1 = _ctx.sent;
                    if (res1 === null || res1 === void 0 ? void 0 : res1.hasError) {
                        ;
                        if ((ref24 = res1 === null || res1 === void 0 ? void 0 : (ref23 = res1.error) === null || ref23 === void 0 ? void 0 : ref23.toLowerCase()) === null || ref24 === void 0 ? void 0 : ref24.includes("Windows socket error".toLowerCase())) {
                            setApiError(api_constants__WEBPACK_IMPORTED_MODULE_14__/* .TECHNICAL_DIFFICULTIES_ERROR */ .Pl);
                        } else {
                            ;
                            setApiError((_error = res1.error) !== null && _error !== void 0 ? _error : utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .GENERIC_ERROR_MESSAGE */ .FI);
                        }
                    } else {
                        ;
                        setUserAccount(res1 === null || res1 === void 0 ? void 0 : (ref25 = res1.Card) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.row) === null || ref26 === void 0 ? void 0 : (ref27 = ref26[0]) === null || ref27 === void 0 ? void 0 : ref27.Account);
                        setCurrentStep(3);
                    }
                case 21:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_CMS__WEBPACK_IMPORTED_MODULE_3__/* .Hero */ .VM, {
                data: {
                    title: 'Create Account',
                    headlineH1: 'Create Account',
                    subhead: 'Manage your prescriptions'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Container */ .W2, {
                maxW: "container.lg",
                paddingX: {
                    base: '3',
                    lg: '0'
                },
                marginBottom: "10",
                children: currentStep === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("form", {
                    onSubmit: step1Form.handleSubmit(onSubmitStep1),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Stack */ .Kq, {
                        spacing: {
                            base: '7',
                            lg: '10'
                        },
                        children: [
                            apiError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_GlobalErrors__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                globalErrors: [
                                    apiError
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .xu, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                                        color: "primary.default",
                                        fontWeight: "bold",
                                        fontSize: {
                                            base: 'lg',
                                            lg: '4xl'
                                        },
                                        children: "Step 1 - Find your account"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                                        fontSize: {
                                            base: 'md',
                                            lg: 'xl'
                                        },
                                        children: "All fields required"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Stack */ .Kq, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Flex */ .kC, {
                                        justifyContent: "space-between",
                                        width: {
                                            base: '100%',
                                            lg: '50%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                                                fontSize: {
                                                    base: "xs",
                                                    md: "md"
                                                },
                                                children: "Rx Number on File"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                                                color: "gray.500",
                                                fontWeight: "light",
                                                fontSize: {
                                                    base: "xs",
                                                    md: "md"
                                                },
                                                as: "button",
                                                type: "button",
                                                onClick: rxImageModalControls.onOpen,
                                                children: "What's this?"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_15__/* .Controller */ .Qr, {
                                        control: step1Form.control,
                                        name: "rxnumber",
                                        defaultValue: "",
                                        rules: {
                                            required: 'This field is required'
                                        },
                                        render: function(param) {
                                            var _field = param.field, onChange = _field.onChange, onBlur = _field.onBlur, name = _field.name, value = _field.value, _fieldState = param.fieldState, error = _fieldState.error, invalid = _fieldState.invalid;
                                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormControl */ .NI, {
                                                isInvalid: !!invalid,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Input */ .II, {
                                                        name: name,
                                                        type: "number",
                                                        value: typeof value === 'string' ? value : '',
                                                        onChange: onChange,
                                                        onBlur: onBlur,
                                                        placeholder: "6 - 8 digit number",
                                                        maxLength: 8,
                                                        width: {
                                                            base: '100%',
                                                            lg: '50%'
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormErrorMessage */ .J1, {
                                                        children: error === null || error === void 0 ? void 0 : error.message
                                                    })
                                                ]
                                            }));
                                        }
                                    })
                                ]
                            }),
                            pharmacySelected && pharmacyLocation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_stores__WEBPACK_IMPORTED_MODULE_6__/* .PharmacyLocation */ .Uy, {
                                pharmacyLocation: pharmacyLocation,
                                onOpen: pharmacyModalControls.onOpen
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .xu, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                                        fontSize: {
                                            base: "xs",
                                            md: "md"
                                        },
                                        children: "Choose the pharmacy where your prescription is located"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Button */ .zx, {
                                        variant: "ld",
                                        marginTop: "5",
                                        width: {
                                            base: '66%',
                                            lg: '25%'
                                        },
                                        onClick: pharmacyModalControls.onOpen,
                                        children: "Select a Pharmacy"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Stack */ .Kq, {
                                spacing: "1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormLabel */ .lX, {
                                        htmlFor: "phone",
                                        fontSize: {
                                            base: "xs",
                                            md: "md"
                                        },
                                        children: "Cell Phone (Required to receive your temporary password)*"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_15__/* .Controller */ .Qr, {
                                        control: step1Form.control,
                                        name: "phone",
                                        defaultValue: (patientStore === null || patientStore === void 0 ? void 0 : (ref10 = patientStore.profile) === null || ref10 === void 0 ? void 0 : ref10.phone) || '',
                                        rules: {
                                            required: 'Please enter a valid phone number'
                                        },
                                        render: function(param) {
                                            var _field = param.field, onChange = _field.onChange, onBlur = _field.onBlur, value = _field.value, name = _field.name, _fieldState = param.fieldState, error = _fieldState.error, invalid = _fieldState.invalid;
                                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormControl */ .NI, {
                                                isInvalid: !!invalid,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Input */ .II, {
                                                        name: name,
                                                        value: (0,utils__WEBPACK_IMPORTED_MODULE_8__/* .getMaskedPhoneValue */ .i7)(value),
                                                        onChange: onChange,
                                                        onBlur: onBlur,
                                                        placeholder: "Enter Phone Number",
                                                        width: {
                                                            base: '100%',
                                                            lg: '50%'
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormLabel */ .lX, {
                                                        htmlFor: "phone",
                                                        color: "gray.500",
                                                        fontSize: {
                                                            base: "sm"
                                                        },
                                                        marginTop: 1,
                                                        children: "*Cell Phone must be on the file at pharmacy"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormErrorMessage */ .J1, {
                                                        children: error === null || error === void 0 ? void 0 : error.message
                                                    })
                                                ]
                                            }));
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Flex */ .kC, {
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Button */ .zx, {
                                    isLoading: isLoading,
                                    variant: "ld",
                                    maxW: {
                                        base: '200px',
                                        lg: '256px'
                                    },
                                    flex: 1,
                                    type: "submit",
                                    children: "Submit"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .xu, {
                                borderRadius: "lg",
                                padding: "6",
                                backgroundColor: "shades.50",
                                marginBottom: {
                                    base: '5',
                                    lg: '10'
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                                    textAlign: "center",
                                    color: "gray.600",
                                    fontSize: {
                                        base: 'sm',
                                        lg: 'md'
                                    },
                                    children: [
                                        "By submitting, you agree to the pharmacy ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_LDLink__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            linkText: "terms and conditions",
                                            href: api_constants__WEBPACK_IMPORTED_MODULE_14__/* .LDTermsAndConditionsURL */ .hE,
                                            target: "blank"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }) : currentStep === 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Stack */ .Kq, {
                    spacing: {
                        base: '7',
                        lg: '10'
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .xu, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                                    color: "primary.default",
                                    fontWeight: "bold",
                                    fontSize: {
                                        base: 'lg',
                                        lg: '4xl'
                                    },
                                    children: "Step 2 - Verification"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                                    fontSize: {
                                        base: 'md',
                                        lg: 'xl'
                                    },
                                    children: "All fields required"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .xu, {
                            borderRadius: "lg",
                            padding: {
                                base: '3',
                                lg: '8'
                            },
                            backgroundColor: "shades.50",
                            marginBottom: {
                                base: '5',
                                lg: '10'
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("form", {
                                onSubmit: step2Form.handleSubmit(onSubmitStep2),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Stack */ .Kq, {
                                    spacing: {
                                        base: '6',
                                        lg: '8'
                                    },
                                    children: [
                                        apiError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_GlobalErrors__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            globalErrors: [
                                                apiError
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Flex */ .kC, {
                                            direction: "column",
                                            textAlign: "center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                                                    textAlign: "center",
                                                    fontWeight: "bold",
                                                    children: "To create your account, please fill below details."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                                                    fontSize: "xs",
                                                    children: "Following successful verification, a unique User ID will be assigned, and a temporary password delivered to your registered mobile number* via text."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Flex */ .kC, {
                                            flexDirection: {
                                                base: 'column',
                                                lg: 'row'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_15__/* .Controller */ .Qr, {
                                                    name: "dob",
                                                    control: step2Form.control,
                                                    rules: {
                                                        required: 'This field is required',
                                                        validate: function(val) {
                                                            var validity = val.match(components_forms_inputs_MaskedDateInput__WEBPACK_IMPORTED_MODULE_9__/* .dateRegexPattern */ .C) ? undefined : 'Please enter a valid date.';
                                                            return validity;
                                                        }
                                                    },
                                                    render: function(param) {
                                                        var _field = param.field, onBlur = _field.onBlur, onChange = _field.onChange, value = _field.value, name = _field.name, _fieldState = param.fieldState, error = _fieldState.error, invalid = _fieldState.invalid;
                                                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormControl */ .NI, {
                                                            isInvalid: !!invalid,
                                                            marginRight: {
                                                                base: '0',
                                                                lg: '3'
                                                            },
                                                            marginBottom: {
                                                                base: '3',
                                                                lg: '0'
                                                            },
                                                            flex: "1",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormLabel */ .lX, {
                                                                    htmlFor: name,
                                                                    children: "Enter your Birthdate (MM/DD/YYYY)"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_forms_inputs_MaskedDateInput__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                                    label: "Date of birth (MM/DD/YYYY)",
                                                                    name: name,
                                                                    type: "datetime",
                                                                    value: value,
                                                                    onBlur: onBlur,
                                                                    onChange: onChange,
                                                                    tone: "critical",
                                                                    message: error === null || error === void 0 ? void 0 : error.message,
                                                                    backgroundColor: "white"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormHelperText */ .Q6, {
                                                                    fontSize: "x-small",
                                                                    children: "*The registered mobile number must be on file at the pharmacy prior to creating the account."
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormErrorMessage */ .J1, {
                                                                    children: error === null || error === void 0 ? void 0 : error.message
                                                                })
                                                            ]
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_15__/* .Controller */ .Qr, {
                                                    control: step2Form.control,
                                                    name: "phn",
                                                    defaultValue: "",
                                                    rules: {
                                                        required: 'This field is required'
                                                    },
                                                    render: function(param) {
                                                        var _field = param.field, onChange = _field.onChange, onBlur = _field.onBlur, name = _field.name, value = _field.value, _fieldState = param.fieldState, error = _fieldState.error, invalid = _fieldState.invalid;
                                                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormControl */ .NI, {
                                                            isInvalid: !!invalid,
                                                            flex: "1",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormLabel */ .lX, {
                                                                    htmlFor: name,
                                                                    children: "Enter your Personal Health Number"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_19__/* .Input */ .II, {
                                                                    name: name,
                                                                    type: "number",
                                                                    value: typeof value === 'string' ? value : '',
                                                                    onChange: onChange,
                                                                    onBlur: onBlur,
                                                                    maxLength: 8,
                                                                    backgroundColor: "white"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_18__/* .FormErrorMessage */ .J1, {
                                                                    children: error === null || error === void 0 ? void 0 : error.message
                                                                })
                                                            ]
                                                        }));
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Flex */ .kC, {
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Button */ .zx, {
                                                isLoading: isLoading,
                                                variant: "ld",
                                                maxW: {
                                                    base: '200px',
                                                    lg: '256px'
                                                },
                                                flex: 1,
                                                type: "submit",
                                                children: "Create Account"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Stack */ .Kq, {
                    spacing: {
                        base: '7',
                        lg: '9'
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "2xl",
                            children: [
                                "Your User ID is ",
                                userAccount
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "2xl",
                            children: utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .CREDENTIALS_SENT_TEXT */ .CP
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .xv, {
                            textAlign: "center",
                            children: "Please save the user id & click the button below"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Flex */ .kC, {
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_LDLink__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                href: utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .PRESCRIPTION_PROFILE_URL */ .aB,
                                variant: "ld",
                                maxW: {
                                    base: '200px',
                                    lg: '256px'
                                },
                                flex: 1,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_20__/* .Button */ .zx, {
                                    variant: "ld",
                                    width: "100%",
                                    children: "I have my Temp Password"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_stores__WEBPACK_IMPORTED_MODULE_6__/* .ChangePharmacyModal */ .T0, _objectSpread({
            }, pharmacyModalControls, {
                setPharmacySelected: setPharmacySelected
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .Modal */ .u_, {
                isCentered: true,
                onClose: rxImageModalControls.onClose,
                isOpen: rxImageModalControls.isOpen,
                size: "sm",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .ModalOverlay */ .ZA, {
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .ModalContent */ .hz, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .ModalCloseButton */ .ol, {
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_21__/* .ModalBody */ .fe, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_17__/* .Flex */ .kC, {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ProxiedImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        src: _public_assets_rx_number_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                                        width: 327,
                                        height: 250,
                                        alt: "RX Number Label"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CreateAccount);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [578,647,774,888,179], function() { return __webpack_exec__(84009); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);